import React from 'react';
import { DivisionDto } from 'src/api/FiretrolApiClient';
import { useOrganization } from 'src/hooks/useOrganization';
import { PersistentSelect } from 'src/design/atoms/PersistentSelect';

interface IDivisionSelectorProps {
  onChange: (divisions: DivisionDto[]) => void;
  initialValue?: number[];
  filter?: (division: DivisionDto) => boolean;
}

export const DivisionSelector = React.memo<IDivisionSelectorProps>(
  ({ onChange, initialValue = [], filter }) => {
    const { divisions } = useOrganization();

    const filteredDivisions = React.useMemo(() => {
      if (filter) {
        return divisions.filter(filter);
      }
      return divisions;
    }, [divisions, filter]);

    const selectedValue = React.useMemo(() => {
      return divisions.filter((d) => (initialValue ?? []).includes(d.id));
    }, [initialValue, divisions]);

    const onValueChange = (value: DivisionDto[]) => {
      onChange(value);
    };

    return (
      <>
        <PersistentSelect
          options={filteredDivisions}
          value={selectedValue}
          onChange={onValueChange}
          placeholder="Search divisions"
          inputProps={{
            label: undefined,
          }}
          emptyMessage="No divisions found..."
          getOptionId={(option) => option.id.toString()}
          getOptionLabel={(option) => option.name}
        />
      </>
    );
  },
);

DivisionSelector.displayName = 'DivisionSelector';
